import { environmentHttpClient as http } from "client/Api/httpClient";
import { HubItemCategoryIdentifierModel } from "client/Api/Hub/common";
import { HubItemKind } from "client/Api/Hub/hubItemCategories";

export function listCategories(
	itemKind: HubItemKind,
	signal?: AbortSignal
): Promise<HubItemCategoryIdentifierModel[]> {
	return http.get<HubItemCategoryIdentifierModel[]>(
		`/Workspace/LiveInformation/HubItemCategories/${itemKind}`,
		undefined,
		{ signal }
	);
}
